import React, { Component } from 'react';
import {
	Button,
	Row,
	Col,
	Form, FormGroup, Label, Input
	} from 'reactstrap';
import Butt from './Butt';
import ActionLink from './ActionLink';
import API from '../API';
import { Apify, ApifyParallel } from '../Apify';
import I18N from '../I18N';
import { T } from '../traks';
import { R } from '../routes';

import LogoAndInfo from './LogoAndInfo';
import XTab from './XTab';
import MU from '../MUTIL';
import { Modal, ModalOpen, ModalClose } from '../Modal';
import { connect } from 'react-redux';
import { parse_date } from '../misc';

function TradeInit(exchange, ticker, portfolio_id) {
	ModalOpen("TradeModal", {exchange, ticker, portfolio_id});
}

function close_trade_dialog() {
	ModalClose();
}

function TradeAbort() {
	close_trade_dialog();
}

class TradeContents extends Component {
	constructor(props) {
		super(props);
		this.state = {
			buysell_xtab_index: 0,
			buy_spend: 0,
			buy_quantity: 0,
			post_in_flight: false,
			...this.get_initial_sell_state_from_props(),
		};
	}

	get_initial_sell_state_from_props() {
		const val = this.props.trade_portfolio_options.CurrentStockQuantity;
		return {
			sell_quantity: val,
			sell_receive: this.get_target_info("sell_receive").calc_from_opposite(val),
		};
	}

	componentDidUpdate(prev_props) {
		if (this.props.trade_portfolio_options.GameId !== prev_props.trade_portfolio_options.GameId) {
			this.setState(this.get_initial_sell_state_from_props());
		}
	}

	calc_a_bunch_of_stuff() {
		const opts = this.props.trade_options;
		const popts = this.props.trade_portfolio_options;

		const brokerage_ratio = (1 + popts.BrokeragePct / 100);
		const effective_buy_rate = popts.StockRateInGameCurrency * brokerage_ratio;
		const effective_sell_rate = popts.StockRateInGameCurrency / brokerage_ratio;

		let available_to_spend  = popts.AvailableToSpend;

		const buy_quantity_max = MU.floor_to_decimals(available_to_spend / effective_buy_rate, opts.NDecimals);

		const sell_receive_max = popts.CurrentStockQuantity * effective_sell_rate;

		return {
			available_to_spend,
			buy_quantity_max,
			sell_receive_max,
			effective_buy_rate,
			effective_sell_rate,
		}
	}

	get_target_info(target) {
		const opts = this.props.trade_options;
		const popts = this.props.trade_portfolio_options;

		const {
			buy_quantity_max,
			available_to_spend,
			sell_receive_max,
			effective_buy_rate,
			effective_sell_rate,
		} = this.calc_a_bunch_of_stuff();

		const info = (() => {
			switch (target) {
			case "buy_quantity":
			case "sell_quantity": return {
				n_decimals: opts.NDecimals,
				rounder: MU.floor_to_decimals,
			};
			case "buy_spend":
			case "sell_receive": return {
				n_decimals: 2,
				rounder: MU.ceil_to_decimals,
			};
			default:
				throw new Error("invalid target");
			}
		})();

		const max = {
			"buy_quantity": buy_quantity_max,
			"buy_spend": available_to_spend,
			"sell_receive": sell_receive_max,
			"sell_quantity": popts.CurrentStockQuantity,
		}[target];

		const scalar = {
			"buy_quantity": 1 / effective_buy_rate,
			"sell_quantity": 1 / effective_sell_rate,
			"buy_spend": effective_buy_rate,
			"sell_receive": effective_sell_rate,
		}[target];

		const correct = (value) => info.rounder(Math.min(max, value), info.n_decimals);

		return {
			...info,
			max,
			correct,
			scalar,
			calc_from_opposite: (opposite_value) => correct(opposite_value * scalar)
		};
	};


	render() {
		const opts = this.props.trade_options;

		const eligible_portfolios = this.props.eligible_portfolios || [];

		const popts = this.props.trade_portfolio_options;

		var rate_element;
		if (popts) {
			const xr = I18N.floatval_unit(popts.StockRateInExchangeCurrency, 2, popts.ExchangeCurrency);
			const gr = I18N.floatval_unit(popts.StockRateInGameCurrency, 2, popts.GameCurrency);
			if (popts.ExchangeCurrency === popts.GameCurrency) {
				rate_element = <span>{gr}</span>;
			} else {
				rate_element = <span>{gr} ({xr})</span>;
			}
			rate_element = <span>1 {this.props.ticker} = {rate_element}</span>;
		}

		const header = (
			<Row className="pb-3">
				<Col>
					<div className="d-flex">
						<div className="mr-auto ad_trade_header">
							<LogoAndInfo exchange={this.props.exchange} ticker={this.props.ticker}/>
						</div>
						<div>
							{rate_element}
						</div>
					</div>
				</Col>
			</Row>
		);

		if (!this.props.me) {
			return (
				<div className="ad_trade_bg p-4">
					{header}
					You are not logged in. Please login or
					create an account to begin trading.
				</div>
			);
		}

		const choose_game = (() => {
			if (eligible_portfolios.length === 0) {
				const start_a_game = () => {
					TradeAbort();
					R.go("/new_game");
				};
				return (
					<div>
						<Row><Col>
							You currently have no active game in which this stock can be traded.
						</Col></Row>
						<Row><Col>
							<Butt onClick={start_a_game}>Start a game</Butt>
						</Col></Row>
					</div>
				);
			}
			const options = eligible_portfolios.map(p => (
				<option key={p.PortfolioId} value={p.PortfolioId}>{p.Name}</option>
			));
			const change_portfolio = (e) => {
				this.props.set_portfolio_id(parseInt(e.target.value, 10));
			};
			return (
				<Row>
					<Col>
						<FormGroup>
							<Label for="trade_game_select"><T>Choose game</T></Label>
							<Input className="ad_trade_gamedropdown font-small" type="select" id="trade_game_select" value={this.props.portfolio_id} onChange={change_portfolio}>
								{options}
							</Input>
						</FormGroup>
					</Col>
				</Row>
			);
		})();

		const {
			buy_quantity_max,
			available_to_spend,
			sell_receive_max,
			effective_buy_rate,
			effective_sell_rate,
		} = this.calc_a_bunch_of_stuff();

		const available_to_spend_element = I18N.floatval_unit(available_to_spend, 2, popts.GameCurrency);
		const current_quantity = I18N.floatval(popts.CurrentStockQuantity, opts.NDecimals);
		var max_per_equity_element = null;
		if(popts.MaxAmountPerStock > 0) {
			max_per_equity_element = (
				<div className="d-flex flex-row justify-content-between w-100 font-small pt-2">
					<div className="w-100 ad_max_per_equity_text p-1"><T>There's a maximum limit of {I18N.floatval_unit(popts.MaxAmountPerStock, 2, popts.GameCurrency)} per equity in this game</T></div>
				</div>
			);
		}
		const inventory_element = (
			<div>
				{max_per_equity_element}
				<div className="d-flex flex-row justify-content-between w-100 font-small pt-2">
					<div className="ad_trade_middletext"><T>Available funds:</T></div>
					<div className="ad_trade_funds_available px-1">{available_to_spend_element}</div>
				</div>
				<div className="d-flex flex-row justify-content-between w-100 font-small pb-4">
					<div className="ad_trade_middletext"><T>Stocks in game:</T></div>
					<div>{current_quantity}</div>
				</div>
			</div>
		);

		const set_buysell_xtab_index = (buysell_xtab_index) => {
			this.setState({buysell_xtab_index});
		};

		var buysell_tabs = [];
		if (popts.Bankroll > 0 && popts.CanBuy) {
			buysell_tabs.push(<T>BUY</T>);
		} else {
			buysell_tabs.push(null);
		}

		if (popts.CurrentStockQuantity > 0) {
			buysell_tabs.push(<T>SELL</T>);
		} else {
			buysell_tabs.push(null);
		}

		var first_non_null_tab = 0;
		for (var index = 0; index < buysell_tabs.length; index++) if (buysell_tabs[index] !== null) first_non_null_tab = index;
		const real_buysell_xtab_index = buysell_tabs[this.state.buysell_xtab_index] === null ? first_non_null_tab : this.state.buysell_xtab_index;

		buysell_tabs = buysell_tabs.map(t => {
			if (t === null) {
				return null;
			} else {
				return <div className="ad_trade_buysell_select">{t}</div>;
			}
		});

		const get_opposite_target = (target) => {
			switch (target) {
			case "buy_spend": return "buy_quantity";
			case "buy_quantity": return "buy_spend";
			case "sell_quantity": return "sell_receive";
			case "sell_receive": return "sell_quantity";
			default: throw new Error("invalid target");
			}
		};

		const input_update = (target, value) => {
			const opposite_target = get_opposite_target(target);
			const opposite_target_info = this.get_target_info(opposite_target);
			this.setState({
				[target]: value,
				[opposite_target]: opposite_target_info.calc_from_opposite(value),
			})
		};

		const clear_zero_input = (e) => {
			if(e.target.value === "0") {
				e.target.value = '';
			}
		}

		const change_float = (e) => {
			input_update(e.target.name, e.target.value + "");
		};

		const blur_float = (e) => {
			if (typeof this.state[e.target.name] === "number") {
				/* if type is number, the value was derived
				 * rather than entered, so leave it alone to
				 * avoid weirdness when tabbing around */
				return
			}
			const target = e.target.name;
			const value = e.target.value;
			const target_info = this.get_target_info(target);
			input_update(target, target_info.correct(value));
		};

		var buysell_ui_element;
		const stock_step = Math.pow(10, -opts.NDecimals);
		var execute_text_element;
		var disable_trade_button = false;

		var trade_request_portfolio_id;
		for (const p of eligible_portfolios) {
			if (trade_request_portfolio_id === undefined || p.PortfolioId === this.props.portfolio_id) {
				trade_request_portfolio_id = p.PortfolioId;
			}
		}

		var trade_request = {
			PortfolioId: trade_request_portfolio_id,
			Exchange: this.props.exchange,
			Ticker: this.props.ticker,
		};

		const exchange = this.props.exchange;
		const date = I18N.datetime_short(new Date(opts.ExchangeOpensAtTs * 1000));

		var notice = null;
		var has_trade_delay = false;

		if (opts.TradeDelaySeconds) {
			has_trade_delay = true;
			const trade_delay_minutes = Math.floor(opts.TradeDelaySeconds / 60);
			const on_read_more_here = () => {
				TradeAbort();
				R.go("/faq");
			}
			notice = (
				<div className="mt-3 ad_trade_notice">*
				<T>Be aware that this trade will go through in {trade_delay_minutes} minutes with the quote at
				that time. This is to avoid the difference between live data and game data. <ActionLink on_click={on_read_more_here}>Read more here</ActionLink>
				</T>
				</div>
			);
		}

		var must_enqueue = has_trade_delay;

		const has_data = !!popts.StockRateInExchangeCurrency;

		if (!has_data) {
			const expected_ipo_date = parse_date(opts.ExpectedIPODate);
			must_enqueue = true;
			if (expected_ipo_date) {
				const expected_ipo_date_element = I18N.date(expected_ipo_date);
				notice = (
					<div className="mt-3 ad_trade_notice">*
					<T>The stock is scheduled for IPO on {expected_ipo_date_element};
					the trade will execute as soon as we
					have the initial data.</T>
					</div>
				);
			} else {
				notice = (
					<div className="mt-3 ad_trade_notice">*
					<T>The stock is not currently available
					for sale due to missing data. The trade
					will execute as soon as we have data.</T>
					</div>
				);
			}
		}

		if (real_buysell_xtab_index === 0) {
			const can_buy_now = opts.CanBuy && opts.ExchangeIsOpen;
			let invoice = [];
			const to_buy = this.get_target_info("buy_quantity").correct(this.state.buy_quantity);
			const total = to_buy * effective_buy_rate;
			const brokerage = total * (popts.BrokeragePct / 100);
			const to_spend = total - brokerage;
			const quantity_element = <span>{I18N.floatval(to_buy, opts.NDecimals)} {this.props.ticker}</span>;

			execute_text_element = (must_enqueue || !can_buy_now) ? <span><T>Enqueue</T></span> : <span><T>Buy</T></span>;
			disable_trade_button = to_buy === 0;

			trade_request.BuyWithAmount = parseFloat(this.state.buy_spend);
			trade_request.DoEnqueue = !can_buy_now;

			if (has_data && !can_buy_now) {
				if (!opts.ExchangeIsOpen) {
					notice = (<div className="mt-3 ad_trade_notice">
						<T>*The exchange ({exchange}) is not
						currently open, but you can enqueue a
						purchase request which will be executed
						when the exchange opens ({date}). The
						amount you choose to spend and the
						stock rate at the time the exchange
						opens will determine the quantity you
						receive.</T>
					</div>);
				} else {
					notice = (<div className="mt-3 ad_trade_notice">
						<T>*The stock cannot currently
						be traded, but you can enqueue
						a purchase request which will
						be executed when trading is
						resumed. The amount you choose
						to spend and the stock rate at
						the time trading resumes will
						determine the quantity you
						receive.</T>
					</div>);
				}
			}

			if (has_data) {
				if (popts.BrokeragePct > 0) {
					invoice.push(
						<div key="trade" className="d-flex ad_trade_invoice">
							<div className="mr-auto">{quantity_element}</div>
							<div>{I18N.floatval_unit(to_spend, 2, popts.GameCurrency)}</div>
						</div>
					);

					const brokerage_pct_element = I18N.floatval(popts.BrokeragePct, 2);
					invoice.push(
						<div key="brokerage" className="d-flex ad_trade_invoice">
							<div className="mr-auto"><T>Brokerage</T> ({brokerage_pct_element }%)</div>
							<div>{I18N.floatval_unit(brokerage, 2, popts.GameCurrency)}</div>
						</div>
					);

					invoice.push(
						<div key="total" className="d-flex ad_trade_invoice">
							<div className="mr-auto w-100 ad_trade_invoice_bold"><T>Total</T></div>
							<div className="text-right ad_trade_invoice_underline_total">{I18N.floatval_unit(total, 2, popts.GameCurrency)}</div>
						</div>
					);
				} else {
					invoice.push(
						<div key="trade_total" className="d-flex ad_trade_invoice">
							<div className="mr-auto w-100 ad_trade_invoice_bold">{quantity_element}</div>
							<div className="text-right ad_trade_invoice_underline_total">{I18N.floatval_unit(to_spend, 2, popts.GameCurrency)}</div>
						</div>
					);
				}
			}

			buysell_ui_element = (
				<div>
					<Row><Col>
						<div className="ad_trade_middletext font-small"><T>Amount to spend</T></div>
						<div className="d-flex align-items-end">
							<input
								name="buy_spend"
								value={this.state.buy_spend}
								min={0}
								max={available_to_spend}
								step={0.01}
								type="number"
								className="mr-auto w-100 ad_trade_amountprice_input ad_input_number_no_spinner"
								onChange={change_float}
								onBlur={blur_float}
								onFocus={clear_zero_input}
							/>
							<div className="ad_trade_amountprice_unit">{popts.GameCurrency}</div>
						</div>
					</Col></Row>
					{has_data && (
					<Row><Col>
						<div className="ad_trade_middletext font-small pt-3"><T>Quantity to buy</T></div>
						<div className="d-flex align-items-end">
							<input
								name="buy_quantity"
								value={this.state.buy_quantity}
								min={0}
								max={buy_quantity_max}
								step={stock_step}
								type="number"
								className="w-100 ad_trade_amountprice_input ad_input_number_no_spinner"
								onChange={change_float}
								onBlur={blur_float}
								onFocus={clear_zero_input}
							/>
							<span className="ad_trade_amountprice_unit">{this.props.ticker}</span>
						</div>
					</Col></Row>
					)}
					<Row className="pt-3"><Col>
						{invoice}
					</Col></Row>
					{notice}
				</div>
			);
		} else {
			const can_sell_now = opts.CanBuy && opts.ExchangeIsOpen;
			let invoice = [];
			const to_sell = this.get_target_info("sell_quantity").correct(this.state.sell_quantity);
			const total = to_sell * effective_sell_rate;
			const brokerage = -total * (popts.BrokeragePct / 100);
			const to_receive = total - brokerage;
			const quantity_element = <span>{I18N.floatval(to_sell, opts.NDecimals)} {this.props.ticker}</span>;

			execute_text_element = (must_enqueue || !can_sell_now) ? <span><T>Enqueue</T></span> : <span><T>Sell</T></span>;
			disable_trade_button = to_sell === 0;

			trade_request.SellQuantity = parseFloat(this.state.sell_quantity);
			trade_request.DoEnqueue = !can_sell_now;

			if (has_data && !can_sell_now) {
				const exchange = this.props.exchange;
				const date = I18N.datetime_short(new Date(opts.ExchangeOpensAtTs * 1000));
				if (!opts.ExchangeIsOpen) {
					notice = (<Row className="mt-3 ad_trade_notice"><Col>
						<T>*The exchange ({exchange}) is not
						currently open, but you can enqueue a
						sale request which will be executed
						when the exchange opens ({date}). The
						quantity you choose to sell and the
						stock rate at the time the exchange
						opens will determine the amount you
						receive.</T>
					</Col></Row>);
				} else {
					notice = (<div className="mt-3 ad_trade_notice">
						<T>*The stock cannot currently
						be traded, but you can enqueue
						a sale request which will be
						executed when trading is
						resumed. The quantity you
						choose to sell and the stock
						rate at the time trading
						resumes will determine the
						amount you receive.</T>
					</div>);
				}
			}

			if (has_data) {
				if (popts.BrokeragePct > 0) {
					invoice.push(
						<div key="trade" className="d-flex ad_trade_invoice">
							<div className="mr-auto">{quantity_element}</div>
							<div>{I18N.floatval_unit(to_receive, 2, popts.GameCurrency)}</div>
						</div>
					);

					const brokerage_pct_element = I18N.floatval(popts.BrokeragePct, 2);
					invoice.push(
						<div key="brokerage" className="d-flex ad_trade_invoice">
							<div className="mr-auto"><T>Brokerage</T> ({brokerage_pct_element }%)</div>
							<div>{I18N.floatval_unit(brokerage, 2, popts.GameCurrency)}</div>
						</div>
					);

					invoice.push(
						<div key="total" className="d-flex ad_trade_invoice">
							<div className="mr-auto w-100 ad_trade_invoice_bold"><T>Total</T></div>
							<div className="text-right ad_trade_invoice_underline_total">{I18N.floatval_unit(total, 2, popts.GameCurrency)}</div>
						</div>
					);
				} else {
					invoice.push(
						<div key="trade_total" className="d-flex ad_trade_invoice">
							<div className="mr-auto w-100 ad_trade_invoice_bold">{quantity_element}</div>
							<div className="text-right ad_trade_invoice_underline_total">{I18N.floatval_unit(to_receive, 2, popts.GameCurrency)}</div>
						</div>
					);
				}
			}

			buysell_ui_element = (
				<div>
					<Row><Col>
						<div className="ad_trade_middletext font-small"><T>Quantity to sell</T></div>
						<div className="d-flex align-items-end">
							<input
								name="sell_quantity"
								value={this.state.sell_quantity}
								type="number"
								min={0}
								max={popts.CurrentStockQuantity}
								step={stock_step}
								className="mr-auto w-100 ad_trade_amountprice_input ad_input_number_no_spinner"
								onChange={change_float}
								onBlur={blur_float}
								onFocus={clear_zero_input}
							/>
							<div className="ad_trade_amountprice_unit">{this.props.ticker}</div>
						</div>
					</Col></Row>
					<Row><Col>
						<div className="ad_trade_middletext font-small pt-3"><T>Amount to receive</T></div>
						<div className="d-flex align-items-end">
							<input
								name="sell_receive"
								type="number"
								value={this.state.sell_receive}
								min={0}
								max={sell_receive_max}
								className="w-100 ad_trade_amountprice_input ad_input_number_no_spinner"
								onChange={change_float}
								onBlur={blur_float}
								onFocus={clear_zero_input}
							/>
							<div className="ad_trade_amountprice_unit">{popts.GameCurrency}</div>
						</div>
					</Col></Row>
					<Row className="pt-3"><Col>
						{invoice}
					</Col></Row>
					{notice}
				</div>
			);
		}

		const execute_trade = () => {
			this.setState({post_in_flight: true});
			API.post("/a/trade", {rq: trade_request}, (response) => {
				this.setState({post_in_flight: false});
				close_trade_dialog();
				R.go_or_reload("/game/:id", {id: popts.GameId});
			});
		};

		return (
			<Form>
				<div className="ad_trade_bg p-4">
					{header}
					{choose_game}
					{inventory_element}
					<XTab
						selected={real_buysell_xtab_index}
						onSelect={set_buysell_xtab_index}
						tabs={buysell_tabs}
					/>
					{buysell_ui_element}
					<Row className="pt-4">
						<Col xs="6">
							<Butt
								disabled={disable_trade_button || this.state.post_in_flight}
								className="ad_trade_buy_btn w-100 px-5 py-3"
								onClick={execute_trade}
							>
								{execute_text_element}
							</Butt>
						</Col>
						<Col xs="6">
							<Butt className="ad_trade_sell_btn w-100 px-5 py-3" onClick={TradeAbort}><T>Cancel</T></Butt>
						</Col>
					</Row>
				</div>
			</Form>
		);
	}
}

var TradePortfolioOptions = (props) => {
	if (props.portfolio_id && !props.trade_portfolio_options) return null;
	return <TradeContents {...props}/>;
}

TradePortfolioOptions = Apify("/a/trade_portfolio_options")
	.with_query_from_props((props) => {
		if (!props.portfolio_id) {
			return null;
		} else {
			return {
				portfolio_id: props.portfolio_id,
				exchange: props.exchange,
				ticker: props.ticker
			};
		}


	})
	.with_refresh_interval(10)
	.with_response_prop("trade_portfolio_options")
	.wrap(TradePortfolioOptions);

class TradeOptionsInner extends Component {
	constructor(props) {
		super(props);
		this.state = {portfolio_id: null};
	}

	render() {
		var portfolio_id = this.state.portfolio_id;

		const eligible_portfolios = this.props.eligible_portfolios || [];
		if (!portfolio_id) {
			for (var eligible_portfolio of eligible_portfolios) {
				if (eligible_portfolio.PortfolioId === this.props.initial_portfolio_id) {
					portfolio_id = this.props.initial_portfolio_id;
					break;
				}
			}

			if (!portfolio_id) {
				if (eligible_portfolios.length > 0) {
					portfolio_id = eligible_portfolios[0].PortfolioId;
				}
			}
		}

		const set_portfolio_id = (pid) => {
			this.setState({portfolio_id: pid});
		};

		if (eligible_portfolios.length > 0) {
			return <TradePortfolioOptions {...this.props} portfolio_id={portfolio_id} set_portfolio_id={set_portfolio_id}/>
		} else {
			const goto_new_game = () => {
				ModalClose();
				R.go("/new_game");
			}
			return (
				<div className="ad_trade_bg p-4">
					<T>
					<div>
					You're not currently playing any game where this stock can be traded.
					</div>
					<div className="mt-2">
					<ActionLink on_click={goto_new_game} className="ad_new_game_button ad_rbtn_25px py-2 px-5">Start a game</ActionLink>
					</div>
					</T>
				</div>
			);
		}
	}
}

var TradeOptions = ApifyParallel(
	(Apify("/z/trade_options")
		.with_query_from_props(props => ({exchange: props.exchange, ticker: props.ticker}))
		.with_response_prop("trade_options")
		.with_refresh_interval(30)
	),
	(Apify("/a/eligible_portfolios")
		.with_predicate(props => !!props.me)
		.with_query_from_props(props => ({exchange: props.exchange, ticker: props.ticker}))
		.with_response_prop("eligible_portfolios")
	)
).wrap((props) => {
	var initial_portfolio_id;
	if (props.portfolio_id) {
		initial_portfolio_id = props.portfolio_id;
	} else {
		initial_portfolio_id = props.LastGamePortfolioIdVisited;
	}
	return <TradeOptionsInner {...props} initial_portfolio_id={initial_portfolio_id}/>;

});

TradeOptions = connect(
	(state) => ({me: state.me, LastGamePortfolioIdVisited: state.LastGamePortfolioIdVisited})
)(TradeOptions);

function TradeButton(props) {
	var butt_code;
	const click = () => {
		TradeInit(props.exchange, props.ticker, props.portfolio_id);
	};

	if(props.portfolio) {
		butt_code = <Button className="ad_portfolio_trade_icon" onClick={click}><img alt="trade_icon" className="ad_portfolio_trade_icon_img" src="/gfx/trade-basket-0.svg"/></Button>;
	} else {
		butt_code = <Butt className="ad_trade_buy_btn ad_w_25 px-5 py-3" onClick={click}><T context="Ticker page trade button">Trade</T></Butt>;
	}

	return butt_code;
}

class TradeModal extends Modal {
	mrender() {
		if (this.props.exchange === undefined) return null;

		return <TradeOptions {...this.props}/>;
	}

	get_name() {
		return "TradeModal";
	}

	get_fullscreen_bg_class() {
		return "ad_trade_modal_panel";
	}

	get_bootstrap_modal_class() {
		return "ad_trade_modal_lg";
	}
}

export {
	TradeModal,
	TradeButton,
	TradeInit,
	TradeAbort,
};



// WEBPACK FOOTER //
// ./src/c/Trade.js